(function () {
  'use strict';

  var KEY = 'cosmoshop:favourites:v1';
  var MAX_ITEMS = 200;
  var lastTrigger = null;
  var drawer = null;
  var supported = false;

  function storageAvailable() {
    try {
      var probe = KEY + ':test';
      window.localStorage.setItem(probe, '1');
      window.localStorage.removeItem(probe);
      return true;
    } catch (error) {
      return false;
    }
  }

  function readItems() {
    if (!supported) return [];
    try {
      var parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      return parsed.filter(function (item) {
        return item && typeof item.id === 'string' && typeof item.handle === 'string' && typeof item.title === 'string' && safeProductUrl(item.url);
      }).slice(0, MAX_ITEMS);
    } catch (error) {
      return [];
    }
  }

  function writeItems(items) {
    if (!supported) return false;
    try {
      window.localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
      return true;
    } catch (error) {
      return false;
    }
  }

  function safeProductUrl(url) {
    if (typeof url !== 'string') return '';
    try {
      var parsed = new URL(url, window.location.origin);
      if (parsed.origin !== window.location.origin || !/\/(products)\/[^/?#]+/.test(parsed.pathname)) return '';
      return parsed.pathname + parsed.search;
    } catch (error) {
      return '';
    }
  }

  function safeImageUrl(url) {
    if (typeof url !== 'string' || !url) return '';
    try {
      var parsed = new URL(url, window.location.href);
      if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return '';
      return parsed.href;
    } catch (error) {
      return '';
    }
  }

  function dataFromButton(button) {
    return {
      id: String(button.getAttribute('data-favourite-id') || ''),
      handle: button.getAttribute('data-favourite-handle') || '',
      title: button.getAttribute('data-favourite-title') || '',
      url: safeProductUrl(button.getAttribute('data-favourite-url') || ''),
      image: safeImageUrl(button.getAttribute('data-favourite-image') || ''),
      price: button.getAttribute('data-favourite-price') || ''
    };
  }

  function isSaved(items, id) {
    return items.some(function (item) { return item.id === id; });
  }

  function updateButtons(items) {
    document.querySelectorAll('[data-cosmoshop-favourite-toggle]').forEach(function (button) {
      var saved = isSaved(items, button.getAttribute('data-favourite-id') || '');
      var title = button.getAttribute('data-favourite-title') || 'this product';
      var label = (saved ? 'Remove ' : 'Add ') + title + (saved ? ' from favourites' : ' to favourites');
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', saved ? 'Remove from favourites' : 'Add to favourites');
    });
  }

  function el(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (typeof text === 'string') element.textContent = text;
    return element;
  }

  function createEmptyState(isUnsupported) {
    var container = el('div', 'cosmoshop-favourites-drawer__empty');
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('class', 'cosmoshop-favourites-heart');
    icon.setAttribute('viewBox', '0 0 32 32');
    icon.setAttribute('fill', 'none');
    icon.setAttribute('stroke', 'currentColor');
    icon.setAttribute('stroke-width', '1.8');
    icon.setAttribute('aria-hidden', 'true');
    var shape = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    shape.setAttribute('d', 'M16 27s-11.5-7.4-11.5-15.4c0-4.2 3.1-7.1 6.8-7.1 2.2 0 3.8 1 4.7 2.7.9-1.7 2.5-2.7 4.7-2.7 3.7 0 6.8 2.9 6.8 7.1C27.5 19.6 16 27 16 27Z');
    icon.appendChild(shape);
    container.appendChild(icon);
    container.appendChild(el('strong', '', isUnsupported ? 'Favourites are unavailable' : 'No favourites saved yet'));
    container.appendChild(el('p', '', isUnsupported ? 'This browser is not allowing local storage. Enable site storage to save favourites.' : 'Open any product and select the heart on its main image to add it here.'));
    var link = el('a', 'cosmoshop-favourites-drawer__shop', 'Browse products');
    link.href = '/collections/all-products';
    container.appendChild(link);
    return container;
  }

  function render() {
    var items = readItems();
    updateButtons(items);
    document.querySelectorAll('[data-cosmoshop-favourites-open]').forEach(function (button) {
      var badge = button.querySelector('[data-cosmoshop-favourites-icon-count]');
      if (badge) {
        badge.textContent = items.length ? String(items.length) : '';
        badge.hidden = items.length === 0;
      }
      button.setAttribute('aria-label', 'View favourites (' + items.length + ' saved)');
    });
    drawer = document.getElementById('cosmoshop-favourites-drawer');
    if (!drawer) return;

    var list = drawer.querySelector('[data-cosmoshop-favourites-list]');
    var count = drawer.querySelector('[data-cosmoshop-favourites-count]');
    if (count) count.textContent = '(' + items.length + ')';
    if (!list) return;
    updateViewToggleState();

    list.replaceChildren();
    if (!supported || !items.length) {
      list.appendChild(createEmptyState(!supported));
      return;
    }

    var fragment = document.createDocumentFragment();
    items.forEach(function (item) {
      var productUrl = safeProductUrl(item.url);
      if (!productUrl) return;
      var card = el('div', 'cosmoshop-favourites-drawer__item');
      var picture = el('a', 'cosmoshop-favourites-drawer__image');
      picture.href = productUrl;
      picture.setAttribute('aria-label', 'View ' + item.title);
      var imageUrl = safeImageUrl(item.image);
      if (imageUrl) {
        var img = el('img');
        img.src = imageUrl;
        img.alt = item.title;
        img.loading = 'lazy';
        picture.appendChild(img);
      }
      var details = el('div', 'cosmoshop-favourites-drawer__details');
      var title = el('a', 'cosmoshop-favourites-drawer__product', item.title);
      title.href = productUrl;
      details.appendChild(title);
      if (item.price) details.appendChild(el('div', 'cosmoshop-favourites-drawer__price', item.price));
      var remove = el('button', 'cosmoshop-favourites-drawer__remove', 'Remove');
      remove.type = 'button';
      remove.setAttribute('data-cosmoshop-favourites-remove', item.id);
      remove.setAttribute('aria-label', 'Remove ' + item.title + ' from favourites');
      details.appendChild(remove);
      card.appendChild(picture);
      card.appendChild(details);
      fragment.appendChild(card);
    });
    list.appendChild(fragment);
  }

  function updateViewToggleState() {
    drawer = document.getElementById('cosmoshop-favourites-drawer');
    if (!drawer) return;
    var panel = drawer.querySelector('[data-cosmoshop-favourites-panel]');
    var toggle = drawer.querySelector('[data-cosmoshop-favourites-view-toggle]');
    if (!panel || !toggle) return;
    var expanded = panel.classList.contains('is-expanded');
    toggle.setAttribute('aria-pressed', expanded ? 'true' : 'false');
    toggle.textContent = expanded ? 'Small view' : 'Change view';
  }

  function toggleDrawerView() {
    drawer = document.getElementById('cosmoshop-favourites-drawer');
    if (!drawer) return;
    var panel = drawer.querySelector('[data-cosmoshop-favourites-panel]');
    if (!panel) return;
    panel.classList.toggle('is-expanded');
    updateViewToggleState();
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    updateViewToggleState();
    document.body.classList.remove('cosmoshop-favourites-open');
    document.querySelectorAll('[data-cosmoshop-favourites-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
    });
    if (lastTrigger && lastTrigger.isConnected) lastTrigger.focus();
  }

  function openDrawer(trigger) {
    drawer = document.getElementById('cosmoshop-favourites-drawer');
    if (!drawer) return;
    lastTrigger = trigger;
    document.querySelectorAll('.cosmoshop-header-account[open], .cosmoshop-header__search details[open]').forEach(function (details) {
      details.removeAttribute('open');
    });
    document.querySelectorAll('[data-cosmoshop-favourites-open]').forEach(function (button) {
      button.setAttribute('aria-expanded', 'true');
    });
    render();
    drawer.hidden = false;
    document.body.classList.add('cosmoshop-favourites-open');
    var panel = drawer.querySelector('[data-cosmoshop-favourites-panel]');
    updateViewToggleState();
    if (panel) panel.focus();
  }

  function updateSavedItems(items) {
    if (writeItems(items)) {
      render();
    } else {
      supported = false;
      render();
    }
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cosmoshop-favourite-toggle]');
    if (toggle) {
      event.preventDefault();
      event.stopPropagation();
      if (!supported) {
        window.alert('Your browser is blocking local storage. Enable it to save favourites.');
        return;
      }
      var product = dataFromButton(toggle);
      if (!product.id || !product.handle || !product.url) return;
      var items = readItems();
      if (isSaved(items, product.id)) {
        updateSavedItems(items.filter(function (item) { return item.id !== product.id; }));
      } else {
        if (items.length >= MAX_ITEMS) {
          window.alert('You can save up to ' + MAX_ITEMS + ' favourites. Remove an item before adding another.');
          return;
        }
        items.unshift(product);
        updateSavedItems(items);
      }
      return;
    }

    var open = event.target.closest('[data-cosmoshop-favourites-open]');
    if (open) {
      event.preventDefault();
      openDrawer(open);
      return;
    }

    if (event.target.closest('[data-cosmoshop-favourites-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }

    if (event.target.closest('[data-cosmoshop-favourites-view-toggle]')) {
      event.preventDefault();
      toggleDrawerView();
      return;
    }

    var remove = event.target.closest('[data-cosmoshop-favourites-remove]');
    if (remove) {
      event.preventDefault();
      var next = readItems().filter(function (item) {
        return item.id !== remove.getAttribute('data-cosmoshop-favourites-remove');
      });
      updateSavedItems(next);
      var panel = drawer && drawer.querySelector('[data-cosmoshop-favourites-panel]');
      updateViewToggleState();
    if (panel) panel.focus();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (!drawer || drawer.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeDrawer();
      return;
    }
    if (event.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]'));
    if (!focusable.length) {
      event.preventDefault();
      drawer.querySelector('[data-cosmoshop-favourites-panel]').focus();
      return;
    }
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement) || document.activeElement === drawer.querySelector('[data-cosmoshop-favourites-panel]'))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  window.addEventListener('storage', function (event) {
    if (event.key === KEY || event.key === null) render();
  });

  document.addEventListener('shopify:section:load', render);

  function init() {
    supported = storageAvailable();
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
